(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kp-color-system"] && !Shopify.designMode) return;
  try {
    (() => {
  if(window.kpColorsLoaded)return;
  window.kpColorsLoaded=true;
  const cardSelector='.product-card[data-product]';
  const localeRoot=window.Shopify?.routes?.root || '/';
  const productURL=handle=>localeRoot+'products/'+encodeURIComponent(handle);
  const groups=new Map(), states=new WeakMap();
  const text=(tr,en)=>document.documentElement.lang.startsWith('tr')?tr:en;
  function read(card){
    const node=card.querySelector('.kp-color-data');
    if(!node)return null;
    try{return JSON.parse(node.textContent)}catch{return null}
  }
  function enhance(card){
    if(card.dataset.kpReady)return;
    const group=read(card);
    if(!group)return;
    card.dataset.kpReady='true';
    card.dataset.kpGroup=group.key;
    groups.set(group.key,group);
    const box=document.createElement('div');
    box.className='kp-colors';
    box.setAttribute('aria-label',text('Renk seçenekleri','Color options'));
    const row=document.createElement('div');row.className='kp-color-row';box.append(row);
    for(const item of group.items){
      const a=document.createElement('a');
      a.className='kp-color';a.href=productURL(item.handle);a.dataset.kpHandle=item.handle;
      a.setAttribute('aria-label',item.color);a.title=item.color;
      const palette={'çöl titanyum':'#cba98d','desert':'#cba98d','titan gri':'#969792','natural grey':'#aaa79e','derin mor':'#514455','gold':'#c6a66b','gümüş':'#c3c7ca','lila':'#baacd1','turkuaz':'#58aeb5','açık yeşil':'#bed2b5','koyu gri':'#55585b','siyah':'#252525','beyaz':'#f6f5f1','bordo':'#642f3c','lacivert':'#26364e','mavi':'#497bb0','açık mavi':'#b5c9e3','turuncu':'#e77c32','pembe':'#edbed0','mor':'#8b719e','yeşil':'#56755d','kırmızı':'#b8373d','gri':'#949799','titanyum':'#aaa79e','taba':'#aa744e','sarı':'#e9c252','şeffaf':'linear-gradient(135deg,#fff 40%,#dce1e5 50%,#fff 60%)'};
      const swatch=palette[item.color.trim().toLocaleLowerCase('tr')];
      if(swatch){a.style.setProperty('--kp-swatch',swatch);a.dataset.kpSolid='true'}

      a.setAttribute('aria-current',String(item.handle===card.dataset.product));
      if(item.image){const img=document.createElement('img');const url=new URL(item.image);url.searchParams.set('width','80');img.src=url.href;img.alt='';img.width=36;img.height=36;img.loading='lazy';a.append(img)}
      const label=document.createElement('span');label.textContent=item.color;a.append(label);row.append(a);
    }
    const status=document.createElement('span');status.className='kp-color-status';status.setAttribute('aria-live','polite');
    const selected=group.items.find(item=>item.handle===card.dataset.product);
    status.textContent=(selected?.color||'')+(card.dataset.kpAvailable==='false'?' · '+text('Tükendi','Sold out'):'');
    box.append(status);
    card.querySelector('.kp-color-data').after(box);
    card.querySelectorAll('.product-card__swatches').forEach(el=>el.hidden=true);
    const title=card.querySelector('.product-card__title a')||card.querySelector('.product-card__title');
    if(title)title.textContent=group.title;
  }
  document.addEventListener('click',async event=>{
    const link=event.target.closest('.kp-color');
    if(!link||event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
    const card=link.closest(cardSelector);if(!card)return;
    event.preventDefault();event.stopPropagation();
    if(card.dataset.kpBusy||link.getAttribute('aria-current')==='true')return;
    card.dataset.kpBusy='true';card.setAttribute('aria-busy','true');
    const status=card.querySelector('.kp-color-status');const prior=status.textContent;status.textContent=text('Renk yükleniyor…','Loading color…');
    try{
      const url=new URL(link.href);url.searchParams.set('view','kp-color-card');
      const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw Error('card');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const replacement=doc.querySelector(cardSelector);
      if(!replacement||replacement.dataset.product!==link.dataset.kpHandle)throw Error('product');
      if(!card.isConnected)return;
      enhance(replacement);replacement.dataset.kpChosen='true';card.replaceWith(replacement);
      replacement.querySelector('.kp-color[aria-current=true]')?.focus({preventScroll:true});
    }catch{
      status.textContent=prior;
      window.location.assign(link.href);
    }finally{delete card.dataset.kpBusy;card.removeAttribute('aria-busy')}
  },true);
  function key(card){return card.dataset.kpGroup||card.dataset.product}
  function dedup(list,seen=new Set()){
    seen.clear();
    for(const item of [...list.children]){
      const card=item.matches(cardSelector)?item:item.querySelector(cardSelector);
      if(!card)continue;enhance(card);
      const id=key(card);if(!id)continue;
      if(card.dataset.kpAvailable==='false'&&!card.dataset.kpChosen){item.remove();continue;}
      if(seen.has(id)){
        const previous=[...list.children].find(other=>other!==item&&key(other.querySelector(cardSelector)||other)===id);
        const previousCard=previous?.matches(cardSelector)?previous:previous?.querySelector(cardSelector);
        if(previousCard?.dataset.kpAvailable==='false'&&card.dataset.kpAvailable==='true'&&!previousCard.dataset.kpChosen){previous.replaceWith(item)}
        else item.remove();
      }else{seen.add(id)}
    }
    return seen;
  }
  function nextURL(raw){if(!raw)return '';const url=new URL(raw,location.href);url.searchParams.delete('section_id');return url.href}
  function initStream(root){
    if(states.has(root))return;
    const search=false;
    const list=search?root.querySelector('.collection-product-list'):root;
    if(!list)return;
    const host=search?root:root.parentElement;
    const state={root,list,host,search,seen:new Set(),next:nextURL(root.dataset.kpNext),busy:false,done:false,visited:new Set(),pageSize:Number(root.dataset.kpPageSize)||24};
    states.set(root,state);dedup(list,state.seen);
    const wrap=document.createElement('div');wrap.className='kp-more-wrap';
    const button=document.createElement('button');button.type='button';button.textContent=text('Daha fazla ürün göster','Show more products');
    const status=document.createElement('p');status.className='kp-more-status';status.setAttribute('aria-live','polite');
    wrap.append(button,status);host.append(wrap);state.button=button;state.status=status;state.wrap=wrap;
    host.querySelectorAll('.kp-native-pagination').forEach(el=>el.hidden=true);
    button.addEventListener('click',()=>fill(state,state.seen.size+state.pageSize));
    const page=Number(root.dataset.kpPage)||1;
    if(page>1){
      const url=new URL(location.href);url.searchParams.delete('page');
      state.next=url.href;state.reset=true;
    }
    fill(state,state.pageSize);
  }
  async function fill(state,target){
    if(state.busy||!state.root.isConnected)return;
    state.busy=true;state.button.disabled=true;
    let pages=0;
    try{
      while(state.next&&(state.reset||state.seen.size<target)&&pages<12){
        const url=state.next;
        if(state.visited.has(url)){state.next='';break}
        state.status.textContent=text('Ürünler yükleniyor…','Loading products…');
        const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw Error('listing');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const incoming=doc.querySelector(state.search?'[data-kp-search-stream]':'[data-kp-stream]');
        if(!incoming)throw Error('grid');
        if(!state.root.isConnected)return;
        const sourceList=state.search?incoming.querySelector('.collection-product-list'):incoming;
        if(state.reset){state.list.replaceChildren();state.seen.clear();state.reset=false}
        if(sourceList){for(const item of [...sourceList.children])state.list.append(item);dedup(state.list,state.seen)}
        if(state.search){
          for(const other of incoming.querySelectorAll('.collection-results')){
            const marker=other.classList.contains('collection-results--articles')?'.collection-results--articles':'.collection-results:not(.collection-results--articles)';
            let targetList=state.root.querySelector(marker);
            if(!targetList){const heading=other.previousElementSibling;if(heading)state.wrap.before(heading);state.wrap.before(other);targetList=other}
            else for(const item of [...other.children]){const href=item.querySelector('a')?.getAttribute('href');if(!href||![...targetList.querySelectorAll('a')].some(a=>a.getAttribute('href')===href))targetList.append(item)}
          }
        }
        state.visited.add(url);state.next=nextURL(incoming.dataset.kpNext);pages++;
      }
      state.status.textContent=state.seen.size+' '+text('ürün modeli gösteriliyor','product models shown');
      if(!state.search)document.querySelectorAll('#ProductCount,#ProductCountDesktop').forEach(el=>{el.textContent=state.seen.size+(state.next?'+':'')+' '+text('ürün modeli','product models')});
      state.button.hidden=!state.next;
    }catch{
      state.status.textContent=text('Yükleme tamamlanamadı. Tekrar deneyebilirsiniz.','Unable to load. Please try again.');
      state.button.hidden=false;
    }finally{state.busy=false;state.button.disabled=false}
  }
  let pending=false;
  function scan(){
    pending=false;
    const detail=document.getElementById('kp-detail-colors');
    const info=document.querySelector('h1')?.parentElement;
    if(detail&&info&&read(detail)){
      if(!info.contains(detail)){const title=info.querySelector('h1');if(title)title.after(detail)}
      enhance(detail);
      detail.hidden=false;
    }
    document.querySelectorAll(cardSelector).forEach(enhance);
    document.querySelectorAll('[data-kp-stream],[data-kp-search-stream]').forEach(initStream);
    document.querySelectorAll('.yesido-selected__grid').forEach(list=>{
      if(list.closest('[data-kp-stream],[data-kp-search-stream]'))return;
      dedup(list);
    });
  }
  scan();
  new MutationObserver(records=>{
    if(pending||!records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1)))return;
    pending=true;requestAnimationFrame(scan);
  }).observe(document.body,{childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

})();
